module.exports = __webpack_public_path__ + "static/media/Aire de leche.cc31b1ad.jpg";